import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";

import Login from "../Pages/Login/Login";
import Splash from "../Pages/Splash/Splash";
import HomePage from "../Pages/HomePage/HomePage";
import Creators from "../Pages/Creators/Creators";
import ContentAnalytics from "../Pages/ContentAnalytics/ContentAnalytics";
import ManageSubscriptions from "../Pages/ManageSubscriptions/ManageSubscriptions";
import Community from "../Pages/Community/Community";
import CreatorForm from "../Pages/Creators/CreatorForm";
import ExerciseCalendar from "../Pages/ExerciseCalendar/ExerciseCalendar";
import Search from "../Pages/Search/Search";
import Register from "../Pages/Register/Register";
import ForgotPassword from "../Pages/ForgotPassword/ForgotPassword";
import PrivateRoute from "../utils/services/PrivateRoute";
import EditProfile from "../Pages/Profile/EditProfile";
import ContentForm from "../Pages/ContentForm/ContentForm";
import PublicRoute from "../utils/services/PublicRoute";
import Profile from "../Pages/Profile/Profile";
import CreateExerciseEvents from "../Pages/ExerciseCalendar/CreateExecriseEvents";
import ExerciseView from "../Pages/ExerciseCalendar/EventView";
import Subscription from "../Pages/SubscriptionForms/Subscriptions";
import AccountSetup from "../Pages/AccountSetup/AccountSetup";
import TourGuide from "../Components/TourGuide";
import Chat from "../Pages/Message/Chat";
import Conversations from "../Pages/Message/Conversations";
import HelpCenter from "../Pages/HelpCenter/HelpCenter";
import CommunityGuidelines from "../Pages/CommunityGuidelines/CommunityGuidelines";
import ResetPassword from "../Pages/ResetPassword/ResetPassword";
import MfaPage from "../Pages/MFAPage/MfaPage";
import RedirectToLogin from "../utils/redirections/RedirectToLogin";
import StripePayment from "../Pages/StripePayment/StripePayment";
import AdminDashboard from "../Pages/Admin/AdminDashboard";
import CreatorTransactions from "../Components/Admin/CreatorTransactions";
import SubmitRequest from "../Pages/SubmitRequest/SubmitRequest";
import Post from "../Pages/PostPage/Post";
import AdminPost from "../Pages/Admin/Post";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const AppRouter = () => {
  const [isSignedUp, setIsSignedUp] = useState(false);

  return (
    <BrowserRouter>
      <TourGuide isSignedUp={isSignedUp} />
      <Routes>
        {/* auth routes  */}
        <Route element={<PublicRoute />}>
          <Route exact path="/" element={<RedirectToLogin />} />
          <Route exact path="/login" element={<Login />} />
          <Route exact path="/register" element={<Register />} />
          <Route exact path="/forgot-password" element={<ForgotPassword />} />
          <Route exact path="/mfa-login" element={<MfaPage />} />
          <Route
            exact
            path="/reset-password/:email"
            element={<ResetPassword />}
          />
        </Route>

        {/* other routes */}
        <Route element={<PrivateRoute role="user" />}>
          <Route exact path="/onboarding" element={<AccountSetup />} />
          <Route path="/dashboard" element={<HomePage />} />
          <Route path="/creator/:id" element={<Profile />} />
          <Route path="/profile/:id" element={<Creators />} />
          <Route path="/chat/:id" element={<Chat />} />
          <Route path="/conversations" element={<Conversations />} />
          <Route path="/edit-profile" element={<EditProfile />} />
          <Route exact path="/onlyhands-helpcenter" element={<HelpCenter />} />
          <Route exact path="/onlyhands-helpcenter" element={<HelpCenter />} />
          <Route exact path="/submit-request" element={<SubmitRequest />} />
          <Route
            exact
            path="/community-guidelines"
            element={<CommunityGuidelines />}
          />
          <Route
            path="/creator/:id/content-analytics"
            element={<ContentAnalytics />}
          />
          <Route
            path="/creator/subscriptions"
            element={<ManageSubscriptions />}
          />
          <Route path="/creator/form" element={<CreatorForm />} />
          <Route
            path="/subscriptionform/:type"
            element={
              <Elements stripe={stripePromise}>
                <Subscription />
              </Elements>
            }
          />
          <Route path="/community" element={<Community />} />
          <Route path="/calendar" element={<ExerciseCalendar />} />
          <Route path="/calendar/exerciseview" element={<ExerciseView />} />
          <Route
            path="/payment-page"
            element={
              <Elements stripe={stripePromise}>
                <StripePayment />
              </Elements>
            }
          />
          <Route
            path="/calendar/createexerciseevents"
            element={<CreateExerciseEvents />}
          />
          <Route path="/search/:searchTerm" element={<Search />} />
          <Route path="/creator/upload-content" element={<ContentForm />} />
          <Route path="/creator/edit-content" element={<ContentForm />} />
          <Route path="/post/:id" element={<Post />} />
        </Route>
        <Route element={<PrivateRoute role="admin" />}>
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/edit-profile" element={<EditProfile />} />
          <Route path="/admin/profile/:id" element={<Creators />} />
          <Route
            path="/admin/creator/transactions/:id"
            element={<CreatorTransactions />}
          />
          <Route path="/admin/post/:id" element={<AdminPost />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
